export const IconClose = ({size = 18}: { size?: number }) => {
    return <svg width={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.666016 0.666687L17.3327 17.3334M0.666016 17.3334L17.3327 0.666687" stroke="currentColor"
              strokeWidth="0.833333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

}